import { render, staticRenderFns } from "./SupplierShow.vue?vue&type=template&id=7d277e8f&scoped=true"
import script from "./SupplierShow.vue?vue&type=script&lang=js"
export * from "./SupplierShow.vue?vue&type=script&lang=js"
import style0 from "./SupplierShow.vue?vue&type=style&index=0&id=7d277e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d277e8f",
  null
  
)

export default component.exports